
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#515358","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.6.933l7.2 7.2"}}),_c('path',{attrs:{"d":"M7.8 8.733a.598.598 0 01-.424-.175l-7.2-7.2a.6.6 0 11.848-.849l7.2 7.2A.6.6 0 017.8 8.733zm0-7.8l-7.2 7.2 7.2-7.2z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M.6 8.733A.598.598 0 01.176 7.71l7.2-7.2a.6.6 0 11.848.849l-7.2 7.2a.598.598 0 01-.424.175z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/objectMenu/remove.svg